// src/App.jsx — ClippCut: one bundle, a screen per path. Paths are real
// folders written by scripts/prerender.mjs, so any static host serves them.
import React, { lazy, Suspense } from 'react'
import { AuthProvider, SignUpView, SignInView, CheckoutReturnView, PlanStatus } from './core/react/auth'
import { Toaster } from './core/react/ui'
import { account, ADMIN } from './account.mjs'
import './config'

const Record = lazy(() => import(/* webpackChunkName: "route-record" */ './screens/Record'))
const Graphics = lazy(() => import(/* webpackChunkName: "route-graphics" */ './screens/Graphics'))

const GATE_COPY = {
  nomark: 'ClippCut Pro removes the small ClippCut mark from your videos.',
  hd: 'ClippCut Pro records in 1080p. Free videos are 720p, which is plenty for most phone screens.',
  long: 'ClippCut Pro records takes up to 5 minutes. Free takes stop at 60 seconds.',
  captions: 'The Punch, Karaoke, Hero and Clean caption styles are in ClippCut Pro. Pop captions and the .srt captions file are free.',
  multi: 'ClippCut Pro makes every shape from one take at the same time: 9:16 for TikTok, Reels and Shorts, 4:5 and 1:1 for the feed, 16:9 for YouTube and LinkedIn.',
  cuts: 'ClippCut Pro cuts the long pauses out of your take for you (jump cuts), on your device.',
  graphics: 'Exporting from the Graphics studio is part of ClippCut Pro: score cards, lower thirds, info cards, callouts that follow a player, title cards, timers, rankings, comparisons and photo or quote cards, as video, a transparent PNG sequence or stills.',
  stickers: 'ClippCut Pro has every animated sticker (bell, comment, share, save, link in bio and more) and every animation style. Like, Heart, Subscribe and Follow with Pop are free.',
}
const goApp = () => { window.location.href = '/record/' }

function Route() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/'
  switch (path) {
    case '/start': return <SignUpView onOpenApp={goApp} appLabel="Open the recorder" />
    case '/signin': return <SignInView onDone={goApp} />
    case '/checkout': return <CheckoutReturnView onOpenApp={goApp} appLabel="Open the recorder" />
    case '/graphics': return <Graphics />
    case '/account': return <div className="account-screen"><div className="account-card"><div className="account-body"><h1>Your plan</h1><PlanStatus /><a className="btn" href="/record/">Open the recorder</a></div></div></div>
    default: return <Record />
  }
}

export default function App() {
  return (
    <AuthProvider account={account} admin={ADMIN} paths={{ start: '/start/', checkout: '/checkout/', signin: '/signin/' }} gateCopy={GATE_COPY} upgradeTitle="Make it yours with ClippCut Pro">
      <Suspense fallback={null}><Route /></Suspense>
      <Toaster />
    </AuthProvider>
  )
}
